import React, { useContext } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Badge, Button, Space } from 'antd';

import ServiceEditModal from '@totem/components/administration/services/ServiceEditModal';
import ServicesContext from '@totem/components/administration/services/ServicesContext';
import ServicesTable from '@totem/components/administration/services/ServicesTable';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

export const ServicesExtra = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { data, onAdd } = useContext(ServicesContext);
  const canEdit =
    permissions.internalSystemAdministrator.hasPermissions(userProfile);

  return (
    <Space>
      <Badge count={data.length} overflowCount={999} offset={[0, -7]}>
        Services&nbsp;&nbsp;
      </Badge>
      {canEdit && (
        <Button size="small" icon={<PlusOutlined />} onClick={onAdd}>
          Add Service
        </Button>
      )}
    </Space>
  );
};

const ServicesLayout = () => (
  <>
    <ServicesTable />
    <ServiceEditModal />
  </>
);

export default ServicesLayout;
